import Link from '@material-ui/core/Link';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import withGS from '../core/withGShoc';
import { globalStyles as styles } from '../core/style/gstheme';
import { ProjectConsumer } from './providers/ProjectProvider';

class Crumb extends React.Component {

    render() {

        const { classes, data, url, dataTest } = this.props;

        return (
            <ProjectConsumer>
                {({ defaultLang }) => (
                    <span data-test={dataTest} className={classes.crumb}>
                        <Link
                            aria-label={"Go to " + (data.title ?
                                data.title[defaultLang] ?
                                    data.title[defaultLang]
                                    :
                                    data.title["und"] ?
                                        data.title["und"]
                                        :
                                        data.id
                                :
                                data.id)}
                            component={RouterLink}
                            className={classes.linkText}
                            to={url}>
                            {data.title ?
                                data.title[defaultLang] ?
                                    data.title[defaultLang]
                                    :
                                    data.title["und"] ?
                                        data.title["und"]
                                        :
                                        data.id
                                :
                                data.id}
                        </Link>
                    </span>

                )}
            </ProjectConsumer>
        );
    }
}

Crumb.propTypes = {
    dataTest: PropTypes.string,
    data: PropTypes.object.isRequired,
    url: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    classes: PropTypes.object
};

export default withRouter(withStyles(styles)(withGS(Crumb, ["ALL"], ["id", "title", "hasEntitlement"], { predicates: ["http://purl.org/dc/terms/title"] })));